import React from 'react'
import { FlexJustify } from 'common/fragments/Flex';
import { NumericInput } from '@blueprintjs/core';

const OrganizationDistribution =(props) =>{
    return (
        <div>
            <FlexJustify  style = {{borderBottom:'1px solid #9d9d9d', width:'100%', marginBottom:10}}>
            <p style={{color:'#9d9d9d', fontSize:12}}>{props.enrollmentDetails.organization.name}</p>
                <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end', alignItems:'center', marginBottom:5}}>
                    <NumericInput fill={false} min={props.enrollmentDetails.enrollCount} style={{display:'flex', flexDirection:'row', justifyContent:'flex-end', alignItems:'flex-end'}}
                        value={props.enrollmentDetails.enrollLimit} name={props.enrollmentDetails.organization.id}
                        onValueChange={(e)=>props.handleInputChange(e,props.enrollmentDetails.organization.id)}>
                    </NumericInput>
                    <span style={{marginLeft:5}}>Seats</span>
                </div>
            </FlexJustify>
        </div>
    );
}

export default OrganizationDistribution ;


// WEBPACK FOOTER //
// ./src/panels/checkout/components/OrganizationDistribution.tsx